import React from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';
import './SearchBar.css';

const SearchBar = ({
  value,
  onChange,
  placeholder = 'Buscar...',
  onClear,
  showClearButton = true,
  disabled = false,
  className = '',
  size = 'medium', // 'small', 'medium', 'large'
  icon = <FaSearch />
}) => {
  const handleClear = () => {
    if (onClear) {
      onClear();
    } else if (onChange) {
      onChange({ target: { value: '' } });
    }
  };

  const searchBarClassName = `search-bar search-bar-${size} ${className}`.trim();

  return (
    <div className={searchBarClassName}>
      <div className="search-bar-icon">
        {icon}
      </div>

      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className="search-bar-input"
      />

      {showClearButton && value && (
        <button
          type="button"
          onClick={handleClear}
          className="search-bar-clear"
          disabled={disabled}
          title="Limpiar búsqueda"
        >
          <FaTimes />
        </button>
      )}
    </div>
  );
};

export default SearchBar;